import {ConfigContext} from '../../config/context/index.js'
import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class MakeSpecificationVehiclesValueObject extends SpecificationVehiclesValueObject {
  constructor({icon, id, name}) {
    super(icon, id, name)
  }

  static createFromId({id}) {
    if (!this.isValidId({id})) return this.empty()

    // Missing icon and name until we have local dictorionary to get them
    return new MakeSpecificationVehiclesValueObject({
      id
    })
  }

  static createFromLiteralsWithIcon({id, name}) {
    const {MAKE_ID_LOGOS_MAP} = ConfigContext.get('vehicles')

    const icon = MAKE_ID_LOGOS_MAP[id] || null
    return MakeSpecificationVehiclesValueObject.createFromLiterals({
      icon,
      id,
      name
    })
  }
}
